/* src/app/order/pages/order-simple-accounts/order-simple-accounts.component.scss */
/*# sourceMappingURL=order-simple-accounts.component.css.map */
